import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationalRouting } from "./constants";
import type { ConversationalRoutingResult } from "./types";
import { isConversationalRoutingResult } from "./validators";

export const getConversationalRouting = reactQueryFetcherAdapter(
  conversationalRouting,
  (signal: AbortSignal, appGroupId: string): Promise<ConversationalRoutingResult> => {
    return fetch(`/${appGroupId}/conversational/routing`, "GET", {}, { signal });
  },
  isConversationalRoutingResult
);
